import { COLOR_LIGHT_YELLOW } from "@website-builder/utilities-index";

export default (
	{
		gridClass,
		titleBackgroundColor = {},
		titleOfCohortDate = "",
		cohortDate = "",
		cohortNextDate = "",
	},
	{ story: { duration, format, shortName, programName } },
) => {
	return {
		gridClass:
			convertGridClass(gridClass) ||
			"col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4",
		format,
		duration,
		shortName: shortName && shortName.trim(),
		programName,
		titleBackgroundColor: titleBackgroundColor.color || COLOR_LIGHT_YELLOW,
		titleOfCohortDate,
		cohortDate,
		cohortNextDate,
	};
};

const convertGridClass = (gridClass = {}) => {
	let bootStrapClass = "";
	const tags = gridClass.tags;
	if (tags && tags.length) {
		tags.forEach(({ text }) => {
			bootStrapClass = `${bootStrapClass} ${text}`;
		});
	}
	return bootStrapClass;
};
